import React, { useEffect } from 'react';

const AdSense = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <div className="adsense-container">

      
      <ins className="adsbygoogle"
           style={{display: 'block'}}
           data-ad-client="ca-pub-8708797024417023"
           data-ad-slot="auto"
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
      
      <ins className="adsbygoogle"
           style={{display: 'block', marginTop: '20px'}}
           data-ad-client="ca-pub-8708797024417023"
           data-ad-slot="auto"
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
      
      <ins className="adsbygoogle"
           style={{display: 'block', marginTop: '20px'}}
           data-ad-client="ca-pub-8708797024417023"
           data-ad-slot="auto"
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
      
      {/* Example of how to add actual Google AdSense:
      <ins className="adsbygoogle"
           style={{display: 'block'}}
           data-ad-client="ca-pub-XXXXXXXXXXXXXXXX"
           data-ad-slot="XXXXXXXXXX"
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
      */}
    </div>
  );
};

export default AdSense;